import { forwardRef } from "react";
import { Input } from "@mui/material";

export const CustomDateInput = forwardRef((props: any, ref) => {
  return <Input {...props} ref={ref} />;
});
